import { PopUpComponent } from "./PopUpComponent";

export class ActionComponent{
    name: string = "";
    actionType: string = "";
    timerLen: number = 0;
    smallButton: boolean = false;
    hasPopUp: boolean = false;
    popUp: PopUpComponent = new PopUpComponent;
    workFileDefinitionConfigured:string = "";
    inboundFileDefinitionConfigured:string = "";

    constructor(name: string = "", actionType: string = "", timerLen: number = 0){
        this.name = name;
        this.actionType = actionType;
        this.timerLen = timerLen;
    }
}